import React from "react";

import "./NoGitHub.css";

export default function NoGitHub() {
  return (
    <div className="NoGitHub">
      <header className="NoGitHub__header">
        <p className="NoGitHub__title">
          No GitHub Repository for this project.
        </p>
      </header>
    </div>
  );
}
